export let routes = [
  {
    path: '/x3-side-courese-arrange',
    name: 'x3-side-courese-arrange',
    component: () => import('./arrange.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/pickerCoureseArrangeFiltrate',
    name: 'pickerCoureseArrangeFiltrate',
    component: () => import('./filtrate/filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsCoureseArrange(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-courese-arrange',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
